module.exports = __webpack_public_path__ + "img/vue1-semelle_rose.eaad78f4.png";